// src/ui/ErrorBoundary.jsx — a render error in one pane shows a message instead of
// blanking the whole app (React unmounts the tree on an uncaught render throw).
import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(p) { super(p); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) { console.error('[allo-web] render error:', err, info); }
  render() {
    if (this.state.err) {
      return (
        <div className="empty-pane">
          <div>
            <div className="big">Something went wrong here</div>
            <div className="sub" style={{ marginTop: 8, color: 'var(--danger)' }}>{String(this.state.err?.message || this.state.err)}</div>
            <button className="btn ghost" style={{ marginTop: 16 }} onClick={() => this.setState({ err: null })}>Try again</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
